import dayjs from "dayjs";

/**
 * Dates as people read them, never «Invalid Date» (BUG-TSD-003, BUG-Z-010, BUG-H-006): a missing, null or unparsable
 * value renders as an empty string, and the caller decides whether to show a dash or hide the whole line. A value
 * is never replaced by «now» or by any other invented time.
 */
export function formatDateTime(value: unknown): string {
  if (value === null || value === undefined || value === "") return "";
  const d = dayjs(String(value));
  return d.isValid() ? d.format("DD.MM.YYYY HH:mm") : "";
}

export function formatDate(value: unknown): string {
  if (value === null || value === undefined || value === "") return "";
  const d = dayjs(String(value));
  return d.isValid() ? d.format("DD.MM.YYYY") : "";
}

/**
 * Quantities as people read them (the client flow of 30.10.2026): «10» for 10.000 pieces, «2,5» for 2.500 kg,
 * thousands split by a space. The value itself is never rounded beyond the 3 digits the API keeps; an empty or
 * unparsable value renders as an empty string.
 */
export function formatQty(value: unknown): string {
  if (value === null || value === undefined || value === "") return "";
  const n = Number(value);
  return Number.isFinite(n) ? n.toLocaleString("ru-RU", { maximumFractionDigits: 3 }) : String(value);
}
